import { matInputOutline } from '@ng-icons/material-icons/outline';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { FieldTypeService } from '@core/services/field-type.service';
import { FormEditorService } from '@core/services/form-editor.service';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matCheckBox,
  matDragIndicator,
  matFunctions,
  matListAlt,
  matStar,
  matTextSnippet,
} from '@ng-icons/material-icons/baseline';
import { TranslateModule } from '@ngx-translate/core';
import { FieldTypeDragPlaceholderComponent } from '@shared/components/dynamic-form/components/field-type-drag-placeholder/field-type-drag-placeholder.component';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { FIELD_TYPE } from '@shared/constants/field-type.const';
import { GlobalEvent } from '@shared/enums/event-bus.enum';
import { EventBusService } from 'ngx-eventbus';

@Component({
  selector: 'app-field-edit-container',
  imports: [
    NgIcon,
    NgbModalModule,
    DragDropModule,
    NgbTooltipModule,
    FieldTypeDragPlaceholderComponent,
    CommonModule,
    TranslateModule,
  ],
  viewProviders: [
    provideIcons({
      matCheckBox,
      matDragIndicator,
      matFunctions,
      matInputOutline,
      matListAlt,
      matStar,
      matTextSnippet,
    }),
  ],
  templateUrl: './field-edit-container.component.html',
})
export class FieldEditContainerComponent {
  field = input<DynamicField>();

  private readonly fieldTypeService = inject(FieldTypeService);
  private readonly formEditorService = inject(FormEditorService);
  private readonly eventBus = inject(EventBusService);

  fieldType = computed(() => {
    return this.fieldTypeService.getFieldType(this.field().controlType);
  });

  FieldType = FIELD_TYPE;

  get editable() {
    return this.formEditorService.editable();
  }

  get cannotEditMessageKey(): string {
    return this.formEditorService.cannotEditMessageKey();
  }

  deleteField(fieldId: string): void {
    this.formEditorService.deleteField(fieldId);
  }

  openSettingsDialog(fieldId: string): void {
    this.eventBus.triggerEvent(GlobalEvent.OpenFieldSettings, fieldId);
  }
}
